import { createFileRoute } from "@tanstack/react-router";

import { RecepturaTemplatesPage } from "@/features/receptura/templates-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/receptura/szablony")({
	component: RecepturaTemplatesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.receptura.szablony",
			location.pathname,
		);
	},
});
